import React from "react";
import { useSelector } from "react-redux";
import { getPaperConfig } from "./paperSize";

const Back = React.forwardRef(({ visitingOneBackPrintRef }, ref) => {
  const { printingData, paper_size } = useSelector((state) => state.printing);
  const paper = getPaperConfig(paper_size);
  // Back card box size is derived from the (possibly padded) front footprint so the back stays
  // 3% larger (full-bleed) plus the size's backBleedX/Y, so it widens with the front padding.
  const backW = paper.back.cardWidth;
  const backH = paper.back.cardHeight;

  const splitPrintingData = (data) => {
    const chunkSize = paper.chunkSize;
    const chunks = [];
    for (let i = 0; i < data?.length; i += chunkSize) {
      chunks?.push(data?.slice(i, i + chunkSize));
    }
    return chunks;
  };
  const chunks = splitPrintingData(printingData);

  return (
    <div
      ref={visitingOneBackPrintRef}
      style={{ boxSizing: "border-box" }}
    >
      <title>DHC Card Back</title>

      {chunks?.map((chunk, chunkIndex) => (
        <div key={chunkIndex} style={{ height: `${paper.pageHeight}px` }}>
          <div
            style={{
              display: "flex",
              alignItems: "start",
              flexDirection: "row-reverse",
              flexWrap: "wrap",
              columnGap: paper.back.columnGap,
              rowGap: paper.back.rowGap,
              paddingLeft: paper.back.paddingLeft,
              paddingRight: paper.back.paddingRight,
              width: paper.containerWidth,
              fontSize: 8,
              // Back mirrored left<->right (row-reverse), right-anchored via paddingRight.
              // A5 centers vertically (verticalCenter); paddingTop then nudges the centered block
              // DOWN by paddingTop/2 (border-box keeps it on-page). A3/A4 stay top-aligned via paddingTop.
              ...(paper.verticalCenter
                ? {
                    height: "100%",
                    boxSizing: "border-box",
                    alignContent: "center",
                    paddingTop: paper.back.paddingTop,
                  }
                : { paddingTop: paper.back.paddingTop }),
            }}
          >
            {chunk?.map((value, index) => {
              return (
                <div
                  key={index}
                  className="item-class-back"
                  style={{
                    backgroundColor: "#ffffff",
                    maxWidth: backW,
                    minWidth: backW,
                    width: backW,
                    maxHeight: backH,
                    minHeight: backH,
                    height: backH,
                    lineHeight: 0,
                    border: "1px solid #f3f3f3",
                    padding: 0,
                    margin: 0,
                    overflow: "hidden",
                  }}
                >
                  <img
                    src={value?.back_image}
                    width={backW}
                    height={backH}
                    alt="back_image"
                    style={{
                      width: "100%",
                      height: "100%",
                      lineHeight: 0,
                      padding: 0,
                      margin: 0,
                    }}
                  />
                </div>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
});

export default Back;
